/* eslint-disable arrow-parens */
// helpers
import { makeActionCreator } from '../../../lib/Utils';
import {
  enabledModels,
  lastDataUpdate,
  localeRestrictions,
  vehicles,
} from '../../../data/vehicles';
import Client from '../../../lib/Client';

export const VEHICLE_TOGGLE_MENU = 'VEHICLE_TOGGLE_MENU';
export const toggleVehicleMenu = makeActionCreator(
  VEHICLE_TOGGLE_MENU,
  'toggle',
);

export const VEHICLE_SET_VEHICLE = 'VEHICLE_SET_VEHICLE';
export const setVehicle = makeActionCreator(VEHICLE_SET_VEHICLE, 'vehicle');

export function updateVehicle(node) {
  // eslint-disable-next-line arrow-parens
  return dispatch => {
    const vehicle = {
      name: node.dataset.name,
      longName: node.dataset.longName,
      shortName: node.dataset.shortName,
      description: node.dataset.description,
      range: node.dataset.range,
      rangeValue: node.dataset.rangeValue,
      model: node.dataset.model,
      modelCode: node.dataset.modelCode,
      driveTrain: node.dataset.driveTrain,
    };
    dispatch(setVehicle(vehicle));
  };
}

export const VEHICLE_SET_VEHICLES = 'VEHICLE_SET_VEHICLES';
export const setVehicles = makeActionCreator(
  VEHICLE_SET_VEHICLES,
  'newVehicles',
);

export const VEHICLE_SET_LABELS = 'VEHICLE_SET_LABELS';
export const setVehicleLabels = makeActionCreator(VEHICLE_SET_LABELS, 'data');

export const VEHICLE_FETCH_SUCCESS = 'VEHICLE_FETCH_SUCCESS';
export const fetchVehicleSuccess = makeActionCreator(
  VEHICLE_FETCH_SUCCESS,
  'vehicles',
);

export const OPTIONS_FETCH_SUCCESS = 'OPTIONS_FETCH_SUCCESS';
export const fetchOptionsSuccess = makeActionCreator(
  OPTIONS_FETCH_SUCCESS,
  'options',
);

/**
 * Merges TTP data with Options API response.
 * @param {*} content TTP vehicles data
 */

/**
 * Merges TTP data with Options API response.
 * @param { Object } content TTP vehicles data
 * @param { Object } vehiclesMap used to map option API model codes with route API model codes.
 * @param { string } region aka country code, eg: 'US', 'FR'
 *
 * @returns { Object } updatedVehicles object that will be stored in state and
 * used to build dropdown.
 */
function getUpdatedVehicles(content, vehiclesMap, region) {
  const updatedVehicles = {};

  // eslint-disable-next-line arrow-parens
  Object.keys(vehiclesMap).forEach(vehicle => {
    const variants = vehiclesMap[vehicle];
    const updatedVariants = [];

    // eslint-disable-next-line arrow-parens
    Object.keys(variants).forEach(variant => {
      // eslint-disable-next-line object-curly-newline
      const {
        driveTrainType,
        rangeType,
        rangeTypeDescription,
        shortName,
      } = variants[variant];
      const { longNames, options } = content;

      const updatedVariant = {
        ...variants[variant],
        name: `${shortName} ${options[rangeType]}`,
        longName: longNames[vehicle],
        description: options[rangeTypeDescription] || options[rangeType],
        range: '{FORMATTED_RANGE_VALUE}',
        modelCode: vehicle,
        driveTrain: options[driveTrainType] || '',
      };

      updatedVariants.push(updatedVariant);
    });

    const vehicleKey = vehicle.toLowerCase();

    if (
      // eslint-disable-next-line operator-linebreak
      !localeRestrictions[vehicleKey] ||
      localeRestrictions[vehicleKey].includes(region) === false
    ) {
      updatedVehicles[vehicle] = updatedVariants;
    }
  });

  return updatedVehicles;
}

/**
 *
 * @param { Object } data incoming from TTP content.
 */
export function fetchVehicle(content) {
  return (dispatch, getState) => {
    const globalState = getState();
    const { App } = globalState;

    let specsOptions = {};

    function OptionsCB(err, res) {
      if (err) {
        specsOptions = { err };
      } else if (res.body) {
        specsOptions = { ...specsOptions, ...res.body.options };
        dispatch(fetchOptionsSuccess(specsOptions));
      }
    }

    // fetches specs options for all variants available at a given date for a given locale.
    // returns an object where every variant has the following information:
    // eg: $MTX03: {acceleration: 4.4, name: "Model X Long Range", range: 325, topspeed: 155}
    // eslint-disable-next-line array-callback-return
    enabledModels.map(model => {
      // Only fetch model option data if this model is supported in current region.
      if (
        // eslint-disable-next-line operator-linebreak
        !localeRestrictions[model] ||
        localeRestrictions[model].includes(App.region) === false
      ) {
        Client.fetchOptions(model, App.locale, lastDataUpdate, OptionsCB);
      }
    });

    const localizedVehicles = getUpdatedVehicles(content, vehicles, App.region);

    dispatch(fetchVehicleSuccess(localizedVehicles));
    dispatch(setVehicle(localizedVehicles.MS[1]));
  };
}

export function hydrateVehicleData(data) {
  // eslint-disable-next-line arrow-parens
  return dispatch => {
    dispatch(fetchVehicle(data));
    dispatch(setVehicleLabels(data));
  };
}

export const VEHICLE_SET_MODEL_CODE = 'VEHICLE_SET_MODEL_CODE';
export const setVehicleModelCode = makeActionCreator(
  VEHICLE_SET_MODEL_CODE,
  'modelCode',
);

export const VEHICLE_SET_NAME = 'VEHICLE_SET_NAME';
export const setVehicleName = makeActionCreator(VEHICLE_SET_NAME, 'name');
